import { ExchangeProtectionWebComponent } from './component/ExchangeProtectionWebComponent';
import { WEB_COMPONENT_EXCHANGE_PROTECTION } from '../../webcomponents.constants';

export { ExchangeProtectionWebComponent };

window.customElements.define(WEB_COMPONENT_EXCHANGE_PROTECTION, ExchangeProtectionWebComponent);
